import { AxiosHeaders, InternalAxiosRequestConfig } from "axios";
import getToken from "../getToken";
import getPlatform from "../getPlatform";

const setAxiosHeader = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  const { accessToken } = getToken() || {};
  const platform = getPlatform();
  const headers = config.headers as AxiosHeaders;
  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }
  if (platform) {
    headers.set("x_app_type", "app");
  }
  return config;
};

export default setAxiosHeader;
